// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2a7jd","label":"CategoryService_label__2XB8T","location":"CategoryService_location__1Up0F"};